import { useEffect } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { useMarketConfig } from '~/app/market-config';

export const OptionsContent = () => {
	const { config } = useMarketConfig();

	useEffect(() => {
		// Disable scroll restoration in chrome base browsers because this over scrolls our auto scrolling on page load
		if ('scrollRestoration' in window?.history) {
			window.history.scrollRestoration = 'manual';
		}

		const optionsContainer = document.getElementById('configurator-options-container');

		const observer = new MutationObserver(() => {
			const headline = document.getElementById('step-headline-container');

			// When headline is found in the dom we know that the steps are loaded
			if (headline) {
				document.body.scrollTop = 0;
				const globalDisclaimer = document.querySelector('#global-disclaimer-bar');
				// If global disclaimer is used as bar, we want to scroll to it. Otherwise scroll the first configurator step into view.
				if (globalDisclaimer) {
					globalDisclaimer.scrollIntoView({ behavior: 'smooth', block: 'start' });
				} else {
					optionsContainer?.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
				// Stop observing after scrolling
				observer.disconnect();
			}
		});

		// Start observing changes in the configurator container
		if (optionsContainer) {
			observer.observe(optionsContainer, { childList: true, subtree: true });
		}

		return () => {
			observer.disconnect();
			// Re-enable scroll restoration on component unmount
			if ('scrollRestoration' in window?.history) {
				window.history.scrollRestoration = 'auto';
			}
		};
	}, []);

	return (
		<>
			{config.configuratorOptions.map(({ id, component }) => (
				<Fragment key={id}>{component}</Fragment>
			))}
		</>
	);
};
